import getOr from 'lodash/fp/getOr'
import * as yup from 'yup'

const needsSchema = yup.object().shape({
  description: yup
    .string()
    .required()
})

const mapPropsToValues = ({ application }) => ({
  description: getOr('', 'needs.description')(application)
})

export default {
  mapPropsToValues,
  validationSchema: needsSchema
}
